import React, { useState, useRef } from 'react';
import { UploadIcon, ImageIcon, FileTextIcon } from 'lucide-react';
export const FileUploader = ({
  onUpload
}) => {
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const handleDragOver = e => {
    e.preventDefault();
    setIsDragging(true);
  };
  const handleDragLeave = () => {
    setIsDragging(false);
  };
  const handleDrop = e => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      handleFiles(Array.from(e.dataTransfer.files));
    }
  };
  const handleFileChange = e => {
    if (e.target.files && e.target.files.length > 0) {
      handleFiles(Array.from(e.target.files));
    }
  };
  const handleFiles = files => {
    onUpload(files);
  };
  return <div data-id="element-788">
      <div className={`border-2 border-dashed rounded-lg p-6 text-center ${isDragging ? 'border-blue-500 bg-blue-50' : 'border-gray-300'}`} onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} data-id="element-789">
        <div className="flex flex-col items-center justify-center" data-id="element-790">
          <UploadIcon className="h-10 w-10 text-gray-400 mb-3" data-id="element-791" />
          <h3 className="text-sm font-medium text-gray-900 mb-1" data-id="element-792">
            Arrastre sus archivos aquí
          </h3>
          <p className="text-xs text-gray-500 mb-4" data-id="element-793">
            o haga clic para seleccionar archivos
          </p>
          <input ref={fileInputRef} type="file" className="hidden" multiple onChange={handleFileChange} id="file-upload" data-id="element-794" />
          <div className="flex gap-2" data-id="element-795">
            <button type="button" onClick={() => fileInputRef.current?.click()} className="px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-796">
              <div className="flex items-center" data-id="element-797">
                <FileTextIcon className="h-4 w-4 mr-2" data-id="element-798" />
                Seleccionar Documentos
              </div>
            </button>
            <button type="button" onClick={() => {
            fileInputRef.current.accept = 'image/*';
            fileInputRef.current?.click();
          }} className="px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-799">
              <div className="flex items-center" data-id="element-800">
                <ImageIcon className="h-4 w-4 mr-2" data-id="element-801" />
                Tomar Foto
              </div>
            </button>
          </div>
        </div>
      </div>
      <p className="mt-2 text-xs text-gray-500 text-center" data-id="element-802">
        Formatos aceptados: JPG, PNG, PDF. Tamaño máximo: 10MB
      </p>
    </div>;
};